import { Component } from '@angular/core';

@Component({
  selector: 'velorum-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss'],
})
export class SocialLinksComponent {
}
